// extracted by mini-css-extract-plugin
export default {"page":"page___rCSWepc","content":"content___rCSWepc","header":"header___rCSWepc","blockedPopup":"blockedPopup___rCSWepc"};